// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3bi7e","load":"styles_load__2C7FQ","wrapperSm":"styles_wrapperSm__2zZJa"};